(() => {
  const start = () => document.querySelectorAll('.gh--how').forEach(section => {
    if (section.dataset.motionReady) return;
    section.dataset.motionReady = 'true';
    const videos = [...section.querySelectorAll('[data-gh-diagram]')];
    const button = section.querySelector('[data-gh-motion-toggle]');
    const loops = section.hasAttribute?.('data-gh-loop');
    if ((!button && !loops) || !videos.length) return;
    const manualPlayback = new WeakSet();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let wantsMotion = !reducedMotion.matches && !navigator.connection?.saveData;
    const nearby = new Set();
    const refreshButton = () => {
      if (!button) return;
      button.textContent = wantsMotion ? 'Ⅱ' : '▶';
      button.setAttribute('aria-label', wantsMotion ? button.dataset.pauseLabel : button.dataset.playLabel);
      button.title = wantsMotion ? button.dataset.pauseLabel : button.dataset.playLabel;
    };
    const update = video => {
      if ((!wantsMotion && !manualPlayback.has(video)) || document.hidden || !nearby.has(video)) {
        video.pause();
        return;
      }
      const source = video.querySelector('source');
      if (!source.getAttribute('src')) {
        source.src = source.dataset.src;
        video.load();
      }
      video.play().catch(error => {
        if (error.name !== 'NotAllowedError' && error.name !== 'NotSupportedError') return;
        video.pause();
        const replay = video.parentElement.querySelector?.('[data-gh-replay]');
        if (replay) replay.hidden = false;
        refreshButton();
      });
    };
    videos.forEach(video => {
      video.muted = true;
      const replay = video.parentElement.querySelector?.('[data-gh-replay]');
      if (replay) {
        replay.hidden = wantsMotion;
        replay.addEventListener('click', () => {
          // Visitors who asked for less motion get one pass per press, not an endless loop.
          if (loops) video.loop = wantsMotion;
          video.currentTime = 0;
          manualPlayback.add(video);
          nearby.add(video);
          replay.hidden = true;
          update(video);
        });
      }
      if (loops) video.addEventListener('ended', () => { manualPlayback.delete(video); if (replay) replay.hidden = false; });
      video.addEventListener('loadeddata', () => video.parentElement.classList.add('is-loaded'));
      video.addEventListener('play', refreshButton);
      video.addEventListener('pause', refreshButton);
      video.addEventListener('error', () => {
        video.parentElement.classList.remove('is-loaded');
        refreshButton();
      });
    });
    if (button) button.hidden = false;
    refreshButton();
    button?.addEventListener('click', () => {
      wantsMotion = !wantsMotion;
      videos.forEach(update);
      refreshButton();
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) nearby.add(entry.target);
          else nearby.delete(entry.target);
          update(entry.target);
        });
      }, { rootMargin:'150px 0px' });
      videos.forEach(video => observer.observe(video));
    } else {
      wantsMotion = false;
      videos.forEach(video => nearby.add(video));
    }
    document.addEventListener('visibilitychange', () => videos.forEach(update));
    reducedMotion.addEventListener('change', event => {
      if (event.matches) { wantsMotion = false; videos.forEach(video => manualPlayback.delete(video)); }
      videos.forEach(update);
      refreshButton();
    });
  });
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once:true });
  document.addEventListener('shopify:section:load', () => {
    if (document.readyState === 'complete') start();
  });
})();
